import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const Home = r => require.ensure([], () => r(require('@/page/index')), 'home');
const First = r => require.ensure([], () => r(require('@/page/firstPage/index_new')), 'first');
const Second = r => require.ensure([], () => r(require('@/page/secondPage/index')), 'second');
const Thirdly = r => require.ensure([], () => r(require('@/page/thirdlyPage/index')), 'thirdly');

const Fourth = r => require.ensure([], () => r(require('@/page/fourthPage/index')), 'fourth');
const FourthDetail = r => require.ensure([], () => r(require('@/page/fourthPage/notice/fourth_detail')), 'fourth-detail');
const FourthList = r => require.ensure([], () => r(require('@/page/fourthPage/notice/fourth_notice-list')), 'fourth-list');

const Fifth = r => require.ensure([], () => r(require('@/page/fifthPage/index')), 'fifth');

export default new Router({
    routes: [{
        path: '/',
        component: Home,
    }, {
        path: '/home',
        component: Home,
        name: 'home',
        children: []
    }, {
        path: '/first', // 模板一 new
        component: First,
        name: 'first',
    }, {
        path: '/second', // 模板二
        component: Second,
        name: 'second',
    }, {
        path: '/thirdly', // 模板三
        component: Thirdly,
        name: 'thirdly',
    }, {
        path: '/fourth', // 模板四
        component: Fourth,
        name: 'fourth',
    }, {
        path: '/fourth-detail', // 模板四-列表页
        component: FourthDetail,
        name: 'fourth-detail',
    }, {
        path: '/fourth-list', // 模板四-详情页
        component: FourthList,
        name: 'fourth-list',
    }, {
        path: '/fifth', // 模板五
        component: Fifth,
        name: 'fifth'
    }, {
        path: '**', // 错误路由
        redirect: '/home' //重定向
    }]
});


// WEBPACK FOOTER //
// ./src/router/index.js